import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    background-color: #10F5B0;
    padding: 2.7em;
    margin-top: 5em;

    .public-layout-description {
        display: flex;
        justify-content: space-between;
    }

    &.form-open {
        background-image: url(images/home/webinar/pattern.svg);
    }

@media all and (max-width: ${variables.tabletL}) {
    .public-layout-description:not(.form-open) {
        display: block;
        text-align: center;

        .copy {
            margin-bottom: 1em;
        }
    }
}

`;